import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { InputField } from '../../components/inputs/inputField';
import { minLengthValidator } from '../../helpers/validators';
import { FormWrapper } from '../../styles/styled';
import Colors from '../../styles/colors';
import SubmitButton from './SubmitButton';

const SignInForm = (props = {}) => {
  const {
    header,
    email,
    password,
    confirmPassword,
    processing,
    error,
    onInputChange,
    onSignIn,
    withHeader,
    submitBtnLabel,
    withForgetPass,
    withConfirmPassword,
  } = props;

  return (
    <SigninCard>
      {withHeader && (
        <div className="row">
          <div className="col-lg-12 center-col text-center">
            <Header>{header}</Header>
            <Line></Line>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <Label>Email</Label>
          <InputField
            type="email"
            // placeholder={'soundwise@email.com'}
            onChange={onInputChange('email')}
            value={email}
            validators={[minLengthValidator.bind(null, 1)]}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-sm-6">
              <Label>Password</Label>
            </div>
            <div className="col-sm-6 text-right">
              {withForgetPass && (
                <Link to="/password_reset">
                  <Forgot>Forgot Password?</Forgot>
                </Link>
              )}
            </div>
          </div>

          <InputField
            type="password"
            // placeholder={'Password'}
            onChange={onInputChange('password')}
            onKeyPress={({ key }) => key === 'Enter' && onSignIn()}
            value={password}
            validators={[minLengthValidator.bind(null, 1)]}
          />

          {withConfirmPassword && (
            <InputField
              type="password"
              // placeholder={'Confirm Password'}
              onChange={onInputChange('confirmPassword')}
              onKeyPress={({ key }) => key === 'Enter' && onSignIn()}
              value={confirmPassword}
              validators={[minLengthValidator.bind(null, 1)]}
            />
          )}
          {!isEmpty(error) && (
            <div className="alert alert-danger text-medium text-left">{error}</div>
          )}
          <SubmitButton loading={processing} onSignIn={onSignIn} label={submitBtnLabel} />
        </div>
      </div>
    </SigninCard>
  );
};

const SigninCard = styled(FormWrapper)`
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-bottom: 20px;
`;

const Header = styled.div`
  opacity: 0.85;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-top: 35px;
  margin-bottom: 20px;
`;

const Line = styled.div`
  border: solid 0.7px rgba(112, 112, 112, 0.05);
  margin-bottom: 30px;
`;

const Label = styled.div`
  opacity: 0.85;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #222222;
  margin-bottom: 10px;
`;

const Forgot = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #f76b1c;
`;

SignInForm.propTypes = {
  header: PropTypes.string,
  email: PropTypes.string,
  password: PropTypes.string,
  confirmPassword: PropTypes.string,
  processing: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onInputChange: PropTypes.func,
  onUseFacebook: PropTypes.func,
  onSignIn: PropTypes.func,
  withHeader: PropTypes.bool,
  withConfirmPassword: PropTypes.bool,
  submitBtnLabel: PropTypes.string,
  withForgetPass: PropTypes.bool,
};

SignInForm.defaultProps = {
  header: 'Hello!',
  email: '',
  password: '',
  confirmPassword: '',
  processing: false,
  error: '',
  onInputChange: () => {},
  onUseFacebook: () => {},
  onSignIn: () => {},
  withHeader: true,
  withConfirmPassword: false,
  submitBtnLabel: 'Sign In',
  withForgetPass: true,
};

export default SignInForm;
